import type { MakeModelValue } from '../../../../features/MakeModelKeywordSearch/MakeModelKeywordSearch.typed';

export const useMotorsSearch = () => {
  const onSelectOption = (value: MakeModelValue | null) => console.log(value);

  return {
    onSelectOption,
  };
};
